<template>
  <div class="video-popup" v-if="videoPost">
    <div class="clickoverlay" @click="close"></div>
    <div class="inner-video">
      <div class="heading-video">
        <h3 class="video-popup-title">
          {{ videoPost.title.rendered.decodeHtmlEntities() }}
        </h3>
        <svg
          @click="close"
          class="close-icon"
          width="19px"
          height="19px"
          viewBox="0 0 19 19"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <defs>
            <path
              d="M0.596919918,0.596919918 C1.39281314,-0.198973306 2.68809035,-0.198973306 3.48398357,0.596919918 L3.48398357,0.596919918 L9.5,6.61293634 L15.5160164,0.596919918 C16.3119097,-0.198973306 17.6071869,-0.198973306 18.4030801,0.596919918 C19.1989733,1.39281314 19.1989733,2.68809035 18.4030801,3.48398357 L18.4030801,3.48398357 L12.387,9.5 L18.4030801,15.5160164 C19.1570842,16.2700205 19.1967686,17.4722252 18.5221334,18.2734083 L18.4030801,18.4030801 C17.6071869,19.1989733 16.3119097,19.1989733 15.5160164,18.4030801 L15.5160164,18.4030801 L9.5,12.3870637 L3.48398357,18.4030801 C2.68809035,19.1989733 1.39281314,19.1989733 0.596919918,18.4030801 C-0.198973306,17.6071869 -0.198973306,16.3119097 0.596919918,15.5160164 L0.596919918,15.5160164 L6.613,9.5 L0.596919918,3.48398357 C-0.157084189,2.72997947 -0.196768616,1.52777478 0.477866638,0.72659166 Z"
              id="path-video-close"
            ></path>
          </defs>
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g>
              <g id="close-video">
                <g>
                  <mask id="mask-video-close" fill="white">
                    <use xlink:href="#path-video-close"></use>
                  </mask>
                  <use
                    id="mask-video-close-use"
                    fill="#41454B"
                    xlink:href="#path-video-close"
                  ></use>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </div>
      <VimeoEmbed
        v-if="videoPost.acf && videoPost.acf.vimeo_video"
        :html="videoPost.acf.vimeo_video"
        autoplay
        :key="activeVideo"
      />
      <div class="video-popup-footer">
        <WpLink :url="videoPost.link" class="video-page-link">
          Gå til videoside
        </WpLink>
      </div>
    </div>
  </div>
</template>

<script>
import VimeoEmbed from "@/components/elements/VimeoEmbed";
import WpLink from "@/components/elements/WpLink";

import { mapGetters } from "vuex";

export default {
  name: "video-lightbox",
  components: {
    VimeoEmbed,
    WpLink
  },
  computed: {
    ...mapGetters(["activeVideo", "getPageById"]),
    videoPost() {
      if (!this.activeVideo) return null;
      return this.getPageById(this.activeVideo) || null;
    }
  },
  watch: {
    activeVideo(val) {
      if (val) {
        $("html").addClass("scroll-block hide-side");
        window.addEventListener("keydown", this.escHandler);
      } else {
        this.releaseScroll();
      }
    }
  },
  destroyed() {
    // route-leave safety: never leave the page scroll-locked
    this.releaseScroll();
    if (this.activeVideo) {
      this.$store.commit("SET_ACTIVE_VIDEO", null);
    }
  },
  methods: {
    close() {
      this.$store.commit("SET_ACTIVE_VIDEO", null);
    },
    escHandler(e) {
      if (e.key === "Escape" || e.keyCode === 27) {
        this.close();
      }
    },
    releaseScroll() {
      $("html").removeClass("scroll-block hide-side");
      window.removeEventListener("keydown", this.escHandler);
    }
  }
};
</script>

<style lang="scss">
@import "./../../assets/scss/mixins.scss";
@import "./../../assets/scss/vars.scss";
.video-popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  color: $fontColor;
  background-color: rgba(rgb(45, 44, 44), 0.9);
  display: flex;
  align-items: center;
  .clickoverlay {
    position: fixed;
    z-index: 5;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    cursor: pointer;
  }
  .inner-video {
    position: relative;
    z-index: 10;
    max-width: 960px;
    width: calc(100% - 30px);
    margin-left: auto;
    margin-right: auto;
    max-height: 90vh;
    overflow: auto;
    background: #fff;
    padding: 24px;
    @include mquery(767px) {
      width: 100%;
      padding: 16px;
    }
  }
  .heading-video {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    .video-popup-title {
      margin: 0;
      padding-right: 15px;
      font-size: 22px;
      @include mquery(767px) {
        font-size: 18px;
      }
    }
    .close-icon {
      height: 22px;
      width: 22px;
      flex: 0 0 auto;
      cursor: pointer;
    }
  }
  .video-popup-footer {
    margin-top: 15px;
    text-align: right;
    .video-page-link {
      color: inherit;
      font-weight: 700;
    }
  }
}
</style>
